import { jsx } from '@emotion/react';
import * as s from './noticeHTML.styles';
import { ArrowRight } from '@next-common/material-ui-icons';
/**
 * notice consent didomi
 * @returns {*}
 * @constructor
 */
function NoticeHTML({ noticeText }) {
    const openPreferences = (event) => {
        if (!event.key || (event.key && event.key === 'enter')) {
            if (window.Didomi.preferences)
                window.Didomi.preferences.show();
        }
    };
    const acceptAll = (event) => {
        if (!event.key || (event.key && event.key === 'enter')) {
            if (window.Didomi.setUserAgreeToAll)
                window.Didomi.setUserAgreeToAll();
        }
    };
    const refuseAll = (event) => {
        if (!event.key || (event.key && event.key === 'enter')) {
            if (window.Didomi.setUserDisagreeToAll)
                window.Didomi.setUserDisagreeToAll();
        }
    };
    return (jsx("div", { className: "containerNotice", 
        // eslint-disable-next-line
        css: s.containerNotice },
        jsx("div", { className: "containerTxt", 
            // eslint-disable-next-line
            css: s.containerTxt },
            jsx("span", { className: "titleTxtStyle", 
                // eslint-disable-next-line
                css: s.titleTxtStyle }, "Vos pr\u00E9f\u00E9rences en mati\u00E8re de cookies"),
            jsx("div", { className: "containerContinueWithoutConsent", onClick: refuseAll, 
                // eslint-disable-next-line
                css: s.containerContinueWithoutConsent },
                jsx("span", { className: "continueWithoutConsentTxtStyle", 
                    // eslint-disable-next-line
                    css: s.continueWithoutConsentTxtStyle }, "Continuer sans accepter"),
                jsx("span", { className: "containerArrow", 
                    // eslint-disable-next-line
                    css: s.containerArrow },
                    jsx(ArrowRight, { fill: "black", width: "12px", height: "12px" }))),
            jsx("p", { className: "paragraphTxtStyle", 
                // eslint-disable-next-line
                css: s.paragraphTxtStyle },
                "Rakuten France et ses",
                ' ',
                jsx("span", { className: "vender-list", onClick: () => {
                        var _a;
                        (_a = window.Didomi.preferences) === null || _a === void 0 ? void 0 : _a.show('vendors');
                        // "window.Didomi.preferences.show('vendors')"
                    } }, "partenaires"),
                ' ',
                "traitent vos donn\u00E9es personnelles (telles que les donn\u00E9es de navigation, les donn\u00E9es de transaction, les informations issues des cookies et d'autres identifiants uniques) en stockant et en acc\u00E9dant aux informations survotre terminal, en analysant activement les caract\u00E9ristiques de celui-ci afin de vous identifier et en utilisant vos donn\u00E9es de g\u00E9olocalisation pr\u00E9cises pour vous proposer des contenus et publicit\u00E9s personnalis\u00E9s, mesurer la performance des annonces et des contenus affich\u00E9s, conna\u00EEtre leur audience et d\u00E9velopper leurs produits. Vous pouvez retirer votre consentement \u00E0 tout moment depuis la rubrique \u00AB Gestion des cookies \u00BB.")),
        jsx("div", { className: "containerBtn", 
            // eslint-disable-next-line
            css: s.containerBtn },
            jsx("div", { onClick: acceptAll, className: "didomi_accept_button", 
                // eslint-disable-next-line
                css: s.didomi_accept_button, onKeyPress: acceptAll },
                jsx("span", null, "Accepter et fermer")),
            jsx("div", { onClick: openPreferences, className: "preferencesBtn", 
                // eslint-disable-next-line
                css: s.preferencesBtn, onKeyPress: openPreferences },
                jsx("span", null, "Param\u00E9trer")))));
}
export default NoticeHTML;
